module.exports = preact;